import { render, staticRenderFns } from "./plan-edit.vue?vue&type=template&id=6541d026&scoped=true"
import script from "./plan-edit.vue?vue&type=script&lang=js"
export * from "./plan-edit.vue?vue&type=script&lang=js"
import style0 from "./plan-edit.vue?vue&type=style&index=0&id=6541d026&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6541d026",
  null
  
)

export default component.exports